<template>
<div>
    
    <!-- 
        <fc-articles />
        <hr class="featured-separator"> 
    -->
    
    <!-- 
        <fc-featured-searches />
        <hr class="featured-separator"> 
    -->

    <div class="round-up-divider">

        <div class="divider-section current-roundup">

            <!-- <div class="weekly-section-heading">
                <h2>Latest Roundup:</h2>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
            </div> -->
            <roundup-article />
            <!-- <div class="weekly-roundup-charts">
                
                <vertical-chart 
                    class="roundup-item"
                    title="Latest Round Up"
                    sub-title="View fact-checks by outlet sorted by output"
                    :start-date="displayStartDate"
                    :end-date="displayEndDate"
                    :data="weekly_roundup_data"
                    />

                <pie-chart 
                    class="roundup-item" 
                    :data="weekly_roundup_data"
                    :loading="loading"
                    />

                <div class="weekly-text roundup-item" >
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                </div>
            </div> -->

            <!-- <div class="weekly-section-footer">
                <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.</p>
                <div class="archive_button" >
                    <a href="/fact_check/weekly_roundup/" >Continue Reading →</a>
                </div>
            </div> -->

        </div>

        <div class="divider-section roundup-links">

            <!-- <roundup-archive-section /> -->

            <div class="round-analysis-section">
                <h3>Analysis</h3>
                <fc-articles />
                <hr class="featured-separator"> 
            </div>


            <!-- <div class="roupup-archive-section">
                <h3>Round up archive</h3>

                <ul>
                    <li>
                        <a href="#">Past round up</a>
                    </li>
                    <li>
                        <a href="#">Past round up</a>
                    </li>
                    <li>
                        <a href="#">Past round up</a>
                    </li>
                </ul>
            </div> -->

        </div>

    </div>

    <div class="weekly-bottom-charts">

        <vertical-chart 
            class="weekly-chart"
            title="Claims By Category"
            sub-title="Number of fact checked claims organized by type"
            :start-date="displayStartDate"
            :end-date="displayEndDate"
            :data="claims_by_type_data"
            />

        <vertical-chart 
            class="weekly-chart"
            title="Claim Sources"
            sub-title="Number of claims by source"
            :start-date="displayStartDate"
            :end-date="displayEndDate"
            :data="claim_sources_by_type_data"
            />

        <vertical-chart 
            class="weekly-chart"
            title="Fact Check Outlets"
            sub-title="View fact-checks by outlet sorted by output"
            :start-date="displayStartDate"
            :end-date="displayEndDate"
            :data="view_by_fact_check_data"
            :hide-zero-values="true"
            />

    </div>

    <!-- <div class="fact-check-review">
        <fact-check-review-table 
            :data="fact_check_review"
            />
    </div> -->

    <div class="fact-checker-claims">
        <fact-checker-claims-table 
            :claims="fact_checker_claims_data.results"
            :start-date="displayStartDate"
            :end-date="displayEndDate"
            :display-links="true"
            :loading="loading"
            :place-holder-number="6"
            />
    </div>

</div>
</template>

<script>

import FcArticles from './FcArticles.vue';
import FcFeaturedSearches from './FcFeaturedSearches.vue';

import VerticalChart from './Charts/VerticalChart.vue';
import PieChart from './Charts/PieChart.vue';

import FactCheckerClaimsTable from './Tables/FactCheckerClaimsTable.vue';
import FactCheckReviewTable from './Tables/FactCheckReviewTable.vue';

import ApiMixin from './ApiMixin.js';
import RoundUpArticle from './RoundUpArticle.vue';

let default_day_range = 150;

export default {
    name: 'fact-check-home',
    components: {
        'roundup-article': RoundUpArticle,
        'fc-articles': FcArticles,
        'fc-featured-searches': FcFeaturedSearches,
        'vertical-chart': VerticalChart,
        'pie-chart': PieChart,
        'fact-checker-claims-table': FactCheckerClaimsTable,
        'fact-check-review-table': FactCheckReviewTable,
    },
    mixins: [
        ApiMixin,
    ],
    data() {
        return {
            loading: true,

            home_search: {
                date_range: dayjs().subtract(default_day_range, 'days').format('YYYY-MM-DD') + ' to ' + dayjs().format('YYYY-MM-DD'),
                sd: dayjs().subtract(default_day_range, 'days').format('YYYY-MM-DD'),

                //start_date: '2017-10-30',
                ed: dayjs().format('YYYY-MM-DD'),
            },

            weekly_roundup_data: [],

            claims_by_type_data: [],

            claim_sources_by_type_data: [],

            view_by_fact_check_data: [],

            fact_checker_claims_data: {
                results: [],
            },

            fact_check_review: [],
        };
    },
    created(){
        this.getHomeData();
    },
    computed: {

        displayStartDate(){
            return dayjs(this.home_search.sd).format("M/DD/YYYY");
        },

        displayEndDate(){
            return dayjs(this.home_search.ed).format("M/DD/YYYY");
        },

    },
    methods: {
        
        async getHomeData(){

            this.loading = true;
            
            let search = Object.assign(this.clone(this.search), this.home_search);
            let res = null;

            res = await this.getData(search, 'home_latest_roud_up_chart');
            this.weekly_roundup_data        = res.data.data.response_data;

            res = await this.getData(search, 'home_claims_by_type');
            this.claims_by_type_data        = res.data.data.response_data;

            res = await this.getData(search, 'home_sources_by_type');
            this.claim_sources_by_type_data = res.data.data.response_data;

            res = await this.getData(search, 'home_view_by_fact_checker');
            this.view_by_fact_check_data    = res.data.data.response_data;

            let claims_search = Object.assign(this.clone(search), {claims_limit: 3});
            res = await this.getData(claims_search, 'home_fact_checker_claims');
            this.fact_checker_claims_data   = res.data.data.response_data;

            res = await this.getData(search, 'home_fact_checker_review');
            this.fact_check_review          = res.data.data.response_data;

            this.loading = false;
        },

    },
}
</script>

<style lang="scss">
#fact-check-app{

    .round-up-divider{
        display: flex;
        flex-direction: column;

        @media screen and (min-width: 768px){
            &{
                flex-direction: row;
                justify-content: space-between;
            }
        }

        .divider-section{
            &.current-roundup{
                flex-basis: 100%;

                @media screen and (min-width: 768px){
                    &{
                        flex-basis: 60%;
                    }
                }

                .weekly-roundup-charts{
                    display: flex;
                    flex-direction: column;

                    @media screen and (min-width: 1180px){
                        &{
                            flex-direction: row;
                            justify-content: space-around;
                        }
                    }

                    .roundup-item{
                        flex-basis: 100%;

                        @media screen and (min-width: 1180px){
                            &{
                                flex-basis: 49%;
                            }
                        }

                        &.weekly-text{
                            flex-basis: 100%;

                            @media screen and (min-width: 1180px){
                                &{
                                    flex-basis: 25%;
                                }
                            }
                        }
                    }
                }
            }

            &.roundup-links{
                margin-left: 0px;
                flex-basis: 100%;

                @media screen and (min-width: 768px){
                    &{
                        margin-left: 40px;
                        flex-basis: 40%;
                    }
                }

                @media screen and (min-width: 1180px){
                    &{
                        margin-left: 80px;
                    }
                }

                // .roupup-archive-section{

                // }

                // .round-analysis-section{

                // }

                h3{
                    font-size: 1.5em;
                }

                ul{
                    padding-inline-start: 10px;

                    li{
                        padding: 10px 0px;
                    }
                }

                .round-analysis-section{
                    .analysis-articles{
                        .the-latest-article{
                            display: flex;
                            flex-direction: column;
                            width: initial !important;

                            .the-latest-content{
                                width: initial !important;
                            }
                        }
                    }
                }
            }

        }

    }

    .weekly-bottom-charts{
        display: flex;
        flex-direction: column;

        @media screen and (min-width: 768px){
            &{
                flex-direction: row;
                justify-content: space-between;

                .weekly-chart{
                    flex-basis: 32%;
                }
            }
        }

        @media screen and (min-width: 1024px){
            &{
                justify-content: space-around;
            }

            .weekly-chart{
                flex-basis: 30%;
            }
        }
    }

    .fact-check-review{
        .fact-checker-average-table-wrapper{
            float: none;
        }
    }
}
</style>